import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { CentroConnectInitialData, getCentroConnectInitialData } from "@tCentro/Services/CENCentroConnectService";

type HandlerType = ApiHandler<
    { onSuccess?: (data: CentroConnectInitialData) => void; onError?: () => void },
    CentroConnectInitialData
>;

export const BeginLoad: HandlerType = props => {
    props.dispatch({
        type: "Custom/CentroConnect/BeginLoadInitialData",
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getCentroConnectInitialData();
    } catch (error) {
        logger.error("Error fetching Centro Connect initial data:", error);
        props.dispatch({
            type: "Custom/CentroConnect/FailedLoadInitialData",
        });
        props.parameter.onError?.();
    }
};

export const DispatchCompleteLoad: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }
    props.dispatch({
        type: "Custom/CentroConnect/CompleteLoadInitialData",
        coworkers: props.apiResult.coworkers,
        expertiseCards: props.apiResult.expertiseCards,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult!);
};

export const chain = [BeginLoad, RequestDataFromApi, DispatchCompleteLoad, ExecuteOnSuccessCallback];

const loadCentroConnectDataHandler = createHandlerChainRunner(chain, "LoadCentroConnectDataHandler");
export default loadCentroConnectDataHandler;
